import React, { useCallback, useMemo } from 'react';

import { t } from 'i18next';

import {
  Box, Menu, Tooltip, styled,
} from '@mui/material';

import { Button, Badge } from '@datanomik/commons-ui';
import { Notification2Line } from '@datanomik/commons-ui/icons';
import { useNotificationsContext } from '@/contexts/notifications';

import { StaticTabsRaw } from '@/views/common/StaticTabs';

import NotificationsList from '../../modules/Notifications/NotificationsList';

import { paperStyles, notificationsTabsStyles } from './styles';

const NotificationsTabs = styled(StaticTabsRaw)(notificationsTabsStyles);

const paperProps = {
  elevation: 0,
  sx: paperStyles,
};

export default function NotificationsButton() {
  const { newNotifications } = useNotificationsContext();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const open = Boolean(anchorEl);

  const items = useMemo(
    () => [
      {
        label: t('Notifications'),
        id: 0,
        component: (
          <NotificationsList
            key="my-notifications"
            type="toolbar"
            handleClose={handleClose}
          />
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <>
      <Box className="dn-notification-button dn-hidden-mobile" sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip title={t('Notifications')}>
          <Button
            onClick={handleClick}
            variant="text"
            color="black"
            startIcon={(
              <Badge
                color="red"
                variant="dot"
                overlap="circular"
                badgeContent={newNotifications}
              >
                <Notification2Line />
              </Badge>
            )}
            size="medium"
          />
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="setting-menu"
        open={open}
        onClose={handleClose}
        PaperProps={paperProps}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <NotificationsTabs items={items} />
      </Menu>
    </>
  );
}
